/** BeyondWords project ID for timothysykes.com */
export const BEYONDWORDS_PROJECT_ID = "9374";

export const BEYONDWORDS_API_BASE = "https://api.beyondwords.io/v1";

const LEGACY_AUDIO_ID_PATTERN = /\/(?:audio|content)\/([^/?]+)/;

/**
 * Extract a legacy podcast / content identifier from a BeyondWords URL payload.
 */
export const parseBeyondWordsContentId = (url) => {
	if (!url || typeof url !== "string") return null;
	const match = url.match(LEGACY_AUDIO_ID_PATTERN);
	return match?.[1] ?? null;
};

/**
 * Resolve the API key from the various payload shapes used across pages.
 */
export const resolveBeyondWordsApiKey = (payload = {}) => {
	if (payload.apiKey) return payload.apiKey;

	const headers = payload.headers ?? {};
	if (headers["X-Api-Key"]) return headers["X-Api-Key"];

	const authorization = headers.Authorization ?? headers.authorization;
	if (typeof authorization === "string") {
		return authorization.replace(/^Bearer\s+/i, "");
	}

	return null;
};

/**
 * Map the v1 API response onto the legacy shape consumed by pages/components:
 *   { id, state, status, published, embedId }
 *
 * `state` mirrors the legacy `state` field (`processed`, etc.).
 * `id` is the v1 content UUID when available (preferred for the new player).
 * `embedId` keeps the original WordPress podcast id for backwards compatibility.
 */
export const normalizeBeyondWordsResponse = (response, legacyPodcastId) => {
	if (!response || typeof response !== "object") return null;

	const status = response.status ?? response.state ?? null;

	return {
		// Legacy podcast id — preferred for the player SDK during migration.
		id: String(legacyPodcastId),
		contentId: response.id ?? null,
		embedId: String(legacyPodcastId),
		state: status,
		status,
		published: response.published ?? false
	};
};

export const buildBeyondWordsContentUrl = (contentId) =>
	`${BEYONDWORDS_API_BASE}/projects/${BEYONDWORDS_PROJECT_ID}/content/${contentId}`;
